import { AdyenResultStatus } from '@customTypes/adyenResultStatus.enum'
import { captureMessage } from '@sentry/react'
import createAdyenCheckout from '@utils/createAdyenCheckout.utils'
import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'

const useGetAdyenPaymentStatus = () => {
    const { order_id: orderId } = useParams<{ order_id: string }>()
    const { search } = useLocation()
    const queryparams = new URLSearchParams(search)
    const redirectResult = queryparams.get('redirectResult')
    const sessionId = queryparams.get('sessionId')
    const [adyenResultCode, setAdyenResultCode] = useState<AdyenResultStatus | null>(null)
    const [loadingAdyenStatus, setLoadingAdyenStatus] = useState(false)

    // This should be executed when we are returning back from some external service provider (like klarna, etc)
    useEffect(() => {
        if (!orderId || !redirectResult || !sessionId) return

        captureMessage(`Getting adyen status - Coming back from external payment service: ${orderId}`)

        const getAdyenSessionData = async (sessionId: string) => {
            setLoadingAdyenStatus(true)

            const adyenInfo = await createAdyenCheckout(
                { id: sessionId },
                (adyenResultCode) => {
                    setAdyenResultCode(adyenResultCode.resultCode as AdyenResultStatus)
                    setLoadingAdyenStatus(false)
                },
                (err) => console.log(err)
            )

            adyenInfo.submitDetails({ details: { redirectResult } })
        }

        getAdyenSessionData(sessionId)
    }, [orderId, redirectResult, sessionId])

    return [adyenResultCode, loadingAdyenStatus]
}

export default useGetAdyenPaymentStatus
